// Libs
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Container } from "../../components/Elemental";
import { connect } from "react-redux";

// CSS
import "./styles.scss";

// Components
import Button from "../../components/Button";
import Warning from "../Warning";

// Actions
import { verifyEmail } from "./actions";
import { changeErr } from "../App/actions";

class VerifyEmailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countdown: 3,
      isVerified: false,
    };
    this.redirectTimer = null;
    this.countdownInterval = null;
  }

  componentDidMount() {
    this.props.changeErr(null);

    const token = this.props.match.params.token;
    if (!token) {
      this.props.changeErr("Token de verificação não encontrado.");
      return;
    }

    // Chamar a API para verificar o e-mail
    this.props.verifyEmail({ token })
      .then(() => {
        this.setState({ isVerified: true });
        this.startCountdown();
      })
      .catch((error) => {
        console.error("Error verifying email:", error);
      });
  }

  componentWillUnmount() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startCountdown = () => {
    this.countdownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          clearInterval(this.countdownInterval);
          return { countdown: 0 };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);

    this.redirectTimer = setTimeout(() => {
      this.props.history.push("/login");
    }, 4000);
  };

  handleGoToLogin = () => {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.props.history.push("/login");
  };

  render() {
    const { localLoading, error, success } = this.props;
    const { countdown, isVerified } = this.state;

    return (
      <div className="verify-email-page">
        <Container className="verify-email-page__container">
          <div className="verify-email-page__content">
            <h1 className="verify-email-page__title">
              {localLoading ? "Verificando..." : isVerified ? "E-mail Verificado!" : "Erro na Verificação"}
            </h1>
            
            {localLoading && (
              <p className="verify-email-page__text">
                Aguarde enquanto verificamos seu e-mail...
              </p>
            )}

            {!localLoading && isVerified && (
              <>
                <p className="verify-email-page__text">
                  Seu e-mail foi verificado com sucesso! 
                  {countdown > 0 && (
                    <> Você será redirecionado para a página de login em <strong>{countdown}</strong> segundo{countdown !== 1 ? 's' : ''}.</>
                  )}
                </p>
                <Warning gutter={30} align="center" success={success} err={error} />
                <Button onClick={this.handleGoToLogin} gutterTop={30}>
                  Ir para Login
                </Button>
              </>
            )}

            {!localLoading && !isVerified && error && (
              <>
                <p className="verify-email-page__text">
                  Não foi possível verificar seu e-mail. O link pode ter expirado ou ser inválido.
                </p>
                <Warning gutter={30} align="center" err={error} />
                <NavLink to="/login">
                  <Button gutterTop={30}>Voltar para Login</Button>
                </NavLink>
              </>
            )}
          </div>
        </Container>
      </div>
    );
  }
}

VerifyEmailPage = connect(
  (state) => ({
    localLoading: state.app.localLoading,
    success: state.app.success,
    error: state.app.err,
  }),
  { verifyEmail, changeErr }
)(VerifyEmailPage);

export default VerifyEmailPage;